import React, { useEffect, useContext } from "react";
import { motion } from "framer-motion";
import PackagesCards from "./PackagesCards";
import PopularPackageLinks from "./PopularPackageLinks";
import { ThemeContext } from "../context/ThemeContext";

const sectionVariant = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 },
  },
};

const TermsAndConditions = () => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section
      className={`${
        isDark ? "dark" : ""
      } w-full mx-auto py-32 bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 mt-10`}
    >
      <motion.div
        initial="hidden"
        animate="visible"
        variants={sectionVariant}
        className="space-y-6 px-4 max-w-5xl mx-auto"
      >
        <h1 className="text-4xl font-bold text-center text-blue-600 dark:text-blue-400 mb-8">
          Terms and Conditions
        </h1>

        <p>
          Unless we specify or grant in our website, you are not legally allowed
          to download, copy, publish distribute and Reproduce the content and
          pictures from our website by any means and by any format. We hereby
          declare that all information presented in this website in terms of
          data, content, videos, audios, and images or other means of content
          materials may be tangible or intangible.
        </p>

        <p>
          All your access to this website will be non-transferable and
          non-exclusive according to these terms and conditions. We also declare
          that we may update any sorts of data such as travel cost and tour
          packages on our website at any time and without any pre-notice. We
          have the right to add, amend or delete any sorts of tour and travel
          services on our website. If you are continuously using this website
          and follow such updates to our terms and conditions, you agree to be
          bound by such of these updates.
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          Users are not allowed for these:
        </h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            As per our agreement license, you are not allowed to trespass,
            attempt to trespass, access to our web servers or use any parts of
            it.
          </li>
          <li>
            Users are not allowed to use our data to which they are not legally
            authorized.
          </li>
          <li>
            You are not allowed to prevent or restrict someone from utilizing
            the website products and services.
          </li>
          <li>
            You are not allowed to post any sorts of unlawful, fraudulent,
            pornographic, threatening and abusive content or information on our
            website.
          </li>
          <li>
            It would be unlawful and illegal to transmit promotional content or
            offers and other commercial communications and spamming.
          </li>
          <li>
            You have no rights to upload, transmit and reproduce any parts of
            information displayed on our website. All our website data is
            copyrighted by us. Finding any kinds of misuse or unauthorized
            access to website data, we are legally allowed to charge against you
            under our terms of the license granted by us.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          Third Party Information:
        </h2>
        <p>
          Users may see the content provided by the third parties or from other
          business sources as well as business references. You would only
          respond to follow, use or access such content. We and any of our
          representatives are not responsible if any of such information is not
          recently updated or up to date. Users are also recommended to be
          cautioned of the reliability and accuracy of such information. The
          Tripocation Holiday Pvt. Ltd. Pvt. Ltd. or any of its subsidiaries are
          not responsible by any means in regard to use and following such kind
          of data. It’s all up to your own risk.
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          We can’t guarantee:
        </h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            However, we do many commercial and reasonable efforts ensuring our
            users for 24 X 7 hours access. But we can’t guarantee or warranty
            for the same.
          </li>
          <li>
            We can’t guarantee for the website compatibility with your systems.
            You are only responsible for your own hardware and software.
          </li>
          <li>
            We can’t guarantee for all time accessibility of our websites during
            temporary suspension. It is due to upgrade or amendments on the
            website. You may also be restricted for access and use this website
            anytime without any prior notice.
          </li>
          <li>
            Company or any of its members are not responsible for any sorts of
            loss or damage while such prohibition or restriction.
          </li>
          <li>
            We can’t guarantee that all references and sources you may see here
            on this website are accurate. Third party links sources may lead you
            to some other sites. In that case, we are not responsible for the
            accuracy, accessibility, and availability of any such info.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          Embedded content information:
        </h2>
        <p>
          All embedded video, audio, images and text in this website are from
          the third party hosted sites like Facebook, Twitter, Youtube,
          Instagram etc. The overall embedded content is subjected to our terms
          and conditions authorized by legal authorities of India and from the
          location at which these content are published or hosted. All these
          contents are under the terms of license imposed by the owner of the
          content. You are only responsible for any fraudulence or failure to
          comply with these terms under those licenses or agreements.
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          User-generated content information:
        </h2>
        <p>
          You further agree that all the views and opinions posted on this
          website by the other users should not be ascribed by us or our board
          of committee members. It would be the sole responsibility of users for
          accuracy, completeness, and reliability of such data expressed or
          generated by the third parties or other users. You are also
          recommended or advised to submit a copyright infringement notification
          to us, in case of any copyright-protected information or content was
          published here on the website. The notification is only liable to send
          by the copyright owner or an authorized agent on behalf of the owner
          with his or her identity proof. All users’ information collected by
          the forms on the website is just used to send promotional content to
          you.
        </p>

        <p>
          All content of this website is our intellectual property right and
          comes under the terms of our license/agreement. We reserve all the
          rights of lawfully adding, removing, updating any sorts of website
          information with any prior knowledge of someone. However, you print or
          download the website content only for non-commercial or personal use.
          But, we don’t lose our authorization and copyright over the content of
          this website. Unless otherwise it’s mentioned, The Company
          “Tripocation Holiday Pvt. Ltd.” has its own copyright over the website
          and all its content by all means. We hereby declare that all comments,
          reviews, ideas, and know-how proposals can be permanently deleted or
          modified anytime without any prior knowledge to the users.
        </p>

        <p className="font-bold uppercase">
          “WE ARE NOT RESPONSIBLE FOR ANY SORTS OF COST, LOSS, AND LIABILITY FOR
          ANY UNAUTHORIZED MEANS OF ACTIONS TO USE OR ACCESS THIS WEBSITE.”
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          No Promotional offers:
        </h2>
        <p>
          The company Tripocation Holiday Pvt. Ltd. and any of its subsidiaries
          never display, send messages and never indulge any of such activities.
          We never promote anything except our own copyrighted travel service
          packages. Nothing in this website constitutes any promotional offers
          to sell and never relates to any of our investment dealings. Customers
          are solely responsible for any of such sorts of commercial deal
          offers. To prevent any sorts of frauds, you are recommended to once
          confirm with us for any such deals. You are only responsible for your
          own decision and use of this website. All these terms of use are
          applicable to our judiciary members.
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          Indemnity
        </h2>
        <p>
          You further understand and agree that any of our employees,
          representatives, directors, agents, contractors, and suppliers would
          be found innocent against liabilities, damages, claims and any sorts
          of costs and expenditures. The company “Tripocation Holiday Pvt. Ltd.”
          reserve the fullest right to defend of all sorts of claims,
          negotiations, and activities for all settlements at our own expense.
          For any kind of policy settlements practices, please refer to our
          privacy policies and PIC (Personal Information Collection) statement.
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          Invalidity:
        </h2>
        <p>
          The companies validity, enforceability, legality is not the subject to
          be affected by any pre illegality, invalidity and unenforceability of
          any or whatever previous under the use of these terms as well as the
          judiciary law.
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          Final Conclusion:
        </h2>
        <p>
          All of the company’s terms and conditions are copyrighted. No one has
          any right to use these terms for their own use by any means. Besides,
          all these terms of use are only for your conveniences, not for any
          sorts of interpretation. All above declared attested terms of use are
          authorized by the India law of tour and travel administrative
          department.
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          TCS 5%
        </h2>
        <p>
          TCS 5% Applicable for all international booking its mandatory for 1st
          Oct 2020 its not an Additional tax tax is advance tax which will be
          credited to client PAN once client file income tax return. TCS 5%
          Amount is nonrefundable once booking confirmed its only refund to
          client by Govt According to Given PAN No.
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          Terms and conditions for tour booking in relation to Covid 19
          pandemic.
        </h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            If due to pandemic the tour cannot be availed altogether then our
            liability will be limited to refund of tour money after deducting
            10% of the tour costs and amount spent towards the booked services
            which is held up with service providers. Once the tour commences
            there shall be no refund.
          </li>
          <li>
            We shall not be bound to refund the amount held up with service
            providers like airlines, hotels or DMC, etc. unless they refund us
            in our bank account.
          </li>
          <li>
            You have to take all the precautions during the travel including
            repatriation expenses if you are stranded due to suspension of
            service abruptly due to law enforcement at your destination or
            transit places. There is no guarantee of any kind of physical or
            financial support during such eventuality where the tour is affected
            due to pandemic like situation.
          </li>
          <li>
            Every country may issue its travel requirements, procedures prior to
            arrival or departure at the destination to be followed at ports,
            rules for medical testing and examination, and so on, which must be
            followed. The company will not be responsible if these procedures
            cause any hindrance in the smooth execution of tours.
          </li>
          <li>
            A copy of such “Procedures for international tourists arriving to
            Dubai” is given hereunder for reference purposes, however, you have
            to get yourself abreast with the latest update for your destination
            on your own by visiting official government websites in this regard
            of the respective country of destination.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          TOUR CONDITIONS
        </h2>
        <p>
          You will have to strictly follow the tour program and comply with the
          terms and conditions of the various contractors/ third party vendors
          such as Hotels, Airlines, Destination Management Companies, Cruise,
          and Insurance etc.
        </p>
        <p>
          You are further requested to be punctual and adhere to the time-lines
          of the tour. In case of you not being punctual you may miss your
          flight, your coach and your meal etc for which you cannot claim any
          damage from our company.
        </p>
        <p>
          You understand that you are traveling in the group, and you shall not
          behave in a manner which causes distress or annoyance to other tour
          participants. In case you behave in a manner which is rowdy and
          indecent, you may be asked to leave the group at your cost and peril.
        </p>
        <p>
          It is understood that there shall be no refund or compensation
          whatsoever for unutilized services whether as a matter of choice or
          caused by your fault or compelled by circumstances such as ill-health,
          weather or any other reason.
        </p>

        <h1 className="text-4xl font-bold text-center text-blue-600 dark:text-blue-400">
          Cancellation Policy
        </h1>
        <p>
          Tripocation Holiday Pvt. Ltd. reserves its right to cancel the booking
          being made by you or even amend the same, if necessary without
          assigning any reasons thereof. Such amendment or cancellation may be
          due to circumstances beyond the control of the company. As per the
          policy of the company, the company in its best endeavors shall book
          alternate Hotels for you, after confirming the dates with you.
          However, at no point of time shall our Company shall be responsible or
          liable to pay any compensation or damage or any other expense or
          business loss suffered by you due to the cancellation or amendment of
          the tour package booked by you.
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          CANCELLATION OF BOOKING BY YOU:
        </h2>
        <p>
          In case you wish to cancel the tour package booked, you must notify us
          in writing through email. Only after the receipt of the same by our
          company staff, it shall be deemed that the said communication has been
          received by our company. The cancellation charges shall apply,
          irrespective of the reason for cancellation whatsoever, including
          medical emergency or pregnancy. You understand and acknowledge that
          these charges are genuine and are the pre-estimate of the damages that
          our Company will suffer on account of cancellation being made by you.
          Further in group bookings, if the cancellations are being made due to
          any reasons, it shall increase the cost of the entire group which cost
          cannot be burdened upon other group members traveling, so the
          cancellation charges are on higher side in order to mitigate that loss
          which the company has to bear on account of you not traveling.
          However, our company in its best endeavor tries to mitigate the loss
          as minimum as possible on you in terms of the cancellation policy. You
          further univocally understand that the said cancellation charges shall
          be paid by you without any dispute and the same are explained to you
          at the time of finalization of the itinerary. If the tour is 100%
          confirmed and delivered there shall be 100% Cancellation charges.
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          CANCELLATION DUE TO REFUSAL OF VISA BY THE EMBASSY:
        </h2>
        <p>
          Granting and rejection of VISAS is the sole discretion of embassy. Our
          Company only acts as a facilitator for obtaining the VISA. The company
          shall, under no circumstances, be held liable or responsible for
          rejection of VISAS and any other related incidental or consequential
          loss, damage, cost or expense. You are required to submit copy of VISA
          granted to you. If the rejection of VISA is intimated by the embassy
          within the cancellation period specified above, then the cancellation
          charges as appearing shall be applicable. You are required to submit
          Refusal of VISA to us. For the purpose of ascertaining the applicable
          cancellation rates, the cancellation under this head will be deemed to
          have been made only when we receive the intimation of VISA rejection
          from the embassy. Subsequently, if you choose to re-apply for the
          VISA, then in that case the cancellation charges if any, shall be
          borne by you from the date of second refusal, if any. If in case we
          have received no intimation from the embassy of accepting of VISA
          application before the departure date of the tour, then in that case
          the maximum cancellation charges shall apply.
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          CANCELLATION FOR WANT OF BALANCE PAYMENT:
        </h2>
        <p>
          The tour package booked by you, can be canceled for want of balance
          payment of tour package, wherein after subsequent request you have
          failed to deposit the balance payment In such a case we reserves the
          rights to cancel the tour package and shall recover the balance
          amount, if any from you after adjusting the advance received. Please
          note that after applying the cancellation policy, if there is any
          amount which is to be refunded it shall be remitted only by way of a
          cheque which shall be drawn in the name of the person whose name the
          booking is made. Company shall not take any request of remittance of
          the amount to any third party or of remittance in form of cash as the
          same is against the company policy.
        </p>

        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          PROCESSING CHARGES:
        </h2>
        <p>
          We hold our right to charge a processing fee which shall be 10% of
          package cost, if booking is withdrawn by you even 5 minutes after
          confirmation of booking reference number being communicated to you
          from our end. Once confirmation is conveyed normal cancellation
          charges shall be applied.
        </p>

        {/* Refund Policy Section */}
        <h2 className="text-2xl font-semibold text-blue-500 dark:text-blue-400">
          Refund Policy:
        </h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>Land Package is non-refundable and non-changeable.</li>
          <li>
            Flight cancellation charges are applicable as per airline policy +
            Rs. 1000 agent service charge.
          </li>
          <li>
            As per the policy, we will refund the money within 7–10 working
            days.
          </li>
        </ul>
      </motion.div>
      <PackagesCards />
      <PopularPackageLinks />
    </section>
  );
};

export default TermsAndConditions;
